import script from "./purchaseSucceeds.vue?vue&type=script&setup=true&lang=ts"
export * from "./purchaseSucceeds.vue?vue&type=script&setup=true&lang=ts"

import "./purchaseSucceeds.vue?vue&type=style&index=0&id=3673aabf&scoped=true&lang=stylus"

import exportComponent from "D:\\project\\web\\vysa_wifi_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3673aabf"]])

export default __exports__